import { Box, Paper, Stack, Text } from '@mantine/core';
import { motion } from 'framer-motion';
import { type FC, useState } from 'react';
import PageWrapper from '@/srcV2/components/PageWrapper';
import { useHostContext } from '@/srcV2/context/HostContext.tsx';
import BusinessWebsiteInput from './components/BusinessWebsiteInput';
import CreateYourAiControls from './components/CreateYourAiControls';
import InformationBlock from './components/InformationBlock';
import { G2_REVIEWS_IMAGE_URL, G2_REVIEWS_URL } from './constants';
import { entranceAnimation } from './utils';

const CreatorIntro: FC = () => {
	const { localization } = useHostContext();
	const [creatorEntryHasInteracted, setCreatorEntryHasInteracted] =
		useState(false);

	const handleInteraction = () => setCreatorEntryHasInteracted(true);

	return (
		<PageWrapper>
			<div
				className="p-4 sm:p-6"
				data-testid="create-new-ai-receptionist"
			>
				<Paper
					classNames={{
						root: 'bg-transparent p-6 shadow-none sm:p-8'
					}}
					radius={16}
					shadow="sm"
				>
					<div className="flex flex-col justify-center align-center">
						<motion.div {...entranceAnimation()}>
							<Stack className="mb-10 sm:mb-12 sm:gap-9 flex text-center">
								<Text
									className="text-3xl leading-9 font-semibold sm:text-6xl sm:leading-12"
									data-testid="create-new-ai-receptionist-title"
								>
									{localization.translate(
										'vibeCreator',
										'createNewAIReceptionist.title'
									)}
								</Text>

								<Text
									className="text-black text-sm sm:text-xl font-medium sm:leading-6"
									data-testid="create-new-ai-receptionist-subtitle"
								>
									{localization.translate(
										'vibeCreator',
										'createNewAIReceptionist.subtitle'
									)}
								</Text>
							</Stack>
						</motion.div>

						<motion.div {...entranceAnimation(0.12)}>
							<Box className="relative mb-20 sm:mb-40">
								<CreateYourAiControls
									hasInteracted={creatorEntryHasInteracted}
									onInteraction={handleInteraction}
								/>
								<BusinessWebsiteInput isDismissed={creatorEntryHasInteracted} />
							</Box>
						</motion.div>

						<motion.div {...entranceAnimation(0.22)}>
							<InformationBlock />

							<div className="flex gap-4 flex-col items-center justify-center">
								<a
									className="w-auto"
									data-testid="create-new-ai-receptionist-g2-link"
									href={G2_REVIEWS_URL}
									rel="noopener"
									target="_blank"
								>
									<img
										alt="G2 reviews"
										src={G2_REVIEWS_IMAGE_URL}
									/>
								</a>

								<Text
									className="text-gray-500"
									data-testid="create-new-ai-receptionist-powered-by"
									size="10px"
								>
									{localization.translate(
										'vibeCreator',
										'createNewAIReceptionist.poweredBy'
									)}{' '}
									<span className="text-black">newo.ai</span>
								</Text>
							</div>
						</motion.div>
					</div>
				</Paper>
			</div>
		</PageWrapper>
	);
};

export default CreatorIntro;
